import { MenuItem, Select } from "@mui/material";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TooltipContainer } from "../tooltipContainer";
import { useTranslation } from "react-i18next";
import "./Paginator.scss";

export const Paginator = (props: PaginatorProps) => {
  const { t } = useTranslation();

  // Clamped so an empty list reads "0-0 of 0" instead of "1-0 of 0".
  const intervalStart =
    props.totalItems === 0
      ? 0
      : (props.currentPage - 1) * props.itemsPerPage + 1;
  const intervalEnd = Math.min(
    props.currentPage * props.itemsPerPage,
    props.totalItems,
  );
  const currentInterval = `${intervalStart}-${intervalEnd}`;

  const previousPage = () => {
    if (props.currentPage === 1) {
      return;
    }
    props.onPreviousPage();
  };

  const nextPage = () => {
    if (props.currentPage * props.itemsPerPage >= props.totalItems) {
      return;
    }
    props.onNextPage();
  };

  return (
    <div className="row paginator-container">
      <div className="col">
        <TooltipContainer text={t("adminPanel.paginator.rowPerPage")}>
          <Select
            className="paginator-select"
            value={props.itemsPerPage}
            IconComponent={ExpandMoreIcon}
            variant="standard"
            disableUnderline={true}
            MenuProps={{
              className: "paginator-select-menu",
              slotProps: {
                list: {
                  dense: true,
                },
              },
            }}
            onChange={(event) =>
              props.onItemsPerPageChange(Number(event.target.value))
            }
          >
            {rowsPerPage.map((x) => (
              <MenuItem key={x} value={x}>
                {x}
              </MenuItem>
            ))}
          </Select>
        </TooltipContainer>
      </div>
      <div className="col text-end align-self-center">
        <span className="me-2">
          {currentInterval} {t("adminPanel.paginator.of")} {props.totalItems}
        </span>
        <TooltipContainer text={t("adminPanel.paginator.previousPage")}>
          <ChevronLeftOutlinedIcon
            className="icon-button"
            onClick={previousPage}
          />
        </TooltipContainer>
        <TooltipContainer text={t("adminPanel.paginator.nextPage")}>
          <ChevronRightOutlinedIcon
            className="icon-button"
            onClick={nextPage}
          />
        </TooltipContainer>
      </div>
    </div>
  );
};

const rowsPerPage = [5, 10, 25, 50, 100];

export interface PaginatorProps {
  itemsPerPage: number;
  currentPage: number;
  totalItems: number;
  onNextPage: () => void;
  onPreviousPage: () => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}
